import React, { useEffect, useState, memo, useMemo } from "react";
import {
  Typography,
  IconButton,
  Dialog,
  DialogContent,
  DialogTitle,
  Button,
  Link,
  CircularProgress,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  TextField,
  FormHelperText,
  Box,
  DialogActions,
  Checkbox,
} from "@material-ui/core";
import { Close } from "@material-ui/icons";
import { useHistory } from "react-router-dom";
import { Service } from "../..";
import { agendamentoOrganico, checarCpf, checarHorarios } from "../../../../services/agendamentoOrganico";
import { cpfMask, removeCpfMask } from "../../../../utils/cpfFormat";
import { dateFormat } from '../../../../utils/dateFormat';
import DateFnsUtils from '@date-io/date-fns';

import { useStyles } from "./style";
import { MdCheckCircleOutline } from "react-icons/md";
import toastMessage from "../../../../utils/handleToastMessage";
import { getServiceWithParams } from "../../../../services/servicos";
import { KeyboardDatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import { isValid } from "date-fns";
import ptBR from "date-fns/locale/pt-BR";
import AsyncSelect from "../../../../Components/AsyncSelect";

interface ServiceProps {
  id: number;
  setor: number;
  slug: string;
  titulo: string;
}
interface Props {
  openSchedulerDialog: boolean;
  setOpenSchedulerDialog: (openSchedulerDialog: boolean) => void;
  service_data: Service;
  unidade_slug: string;
}

interface SchedulerProps {
  id: number,
  cpf: string,
  servico: number,
  status: string,
  data_solicitacao: string,
  unidade: string,
  ticket: string,
  data: string,
  prioridade: boolean,
  user: null,
  hora: string,
  setor: {
    id: number;
    nome: string;
    sigla: string;
  },
  guiche: {
    id: number;
    ordem: number;
    tipo: string;
  },
  tipo: string,
  hora_inicio: string,
  para_dependente: boolean,
  nome: string,
  updated_at: string,
  tipo_documento: 'nenhum' | 'cpf' | 'rg' | 'titulo';
  documento: string | null;
  protocolo: string;
  unidade_nome: string;
}

interface IdentificationProps {
  key: 'rg' | 'titulo' | 'nenhum' | 'cpf';
  value: string;
}
const identification: IdentificationProps[] = [
  {
    key: 'rg',
    value: 'RG'
  },
  {
    key: 'titulo',
    value: 'Título de eleitor'
  },
  {
    key: 'nenhum',
    value: 'Não informar'
  },
]

function DialogNotAttend({
  setOpenSchedulerDialog,
  openSchedulerDialog,
  service_data,
  unidade_slug
}: Props): JSX.Element {
  const [loading, setLoading] = useState<boolean>(false);
  const [nome, setNome] = useState<string>('');
  const [nomeValidationMessage, setNomeValidationMessage] = useState<string | undefined>();
  const [cpf, setCpf] = useState<string>('');
  const [cpfValidationMessage, setCpfValidationMessage] = useState<string | undefined>();
  const [serviceSelected, setServiceSelected] = useState<ServiceProps>();
  const [IsSavedScheduler, setIsSavedScheduler] = useState(false);
  const [schedulerData, setSchedulerData] = useState<SchedulerProps>();
  const [errorMessage, setErrorMessage] = useState<string | undefined>();
  const [loadingService, setLoadingService] = useState(false);
  const [errorAlert, setErrorAlert] = useState(false);
  const [identSelected, setIdentSelected] = useState<IdentificationProps>({ key: 'nenhum', value: 'Não informar' });
  const [hoursList, setHoursList] = useState<string[]>([]);
  const [hasCPF, setHasCPF] = useState<boolean>(false);
  const [documentErrorMessage, setDocumentErrorMessage] = useState<string | undefined>();
  const [documento, setDocumento] = useState<string | undefined>('');
  const [searchService, setSearchService] = useState<any>();
  const [unitySelected, setUnitySelected] = useState<string | undefined>();
  const [isFutureDate, setIsFutureDate] = useState<boolean>(false);
  const [selectedDate, setSelectedDate] = useState<Date>(new Date());
  const [hourSelected, setHourSelected] = useState<string | undefined>();
  const [validateQueryService, setValidateQueryService] = useState<boolean>(true);

  const classes = useStyles();
  const history = useHistory();

  const handleCheckHours = async (serviceID: number, unity: string, date?: Date) => {
    setLoadingService(true);
    try {
      const token: string | null = localStorage.getItem(
        "gov_access_token_siseci"
      );
      const { data } = await checarHorarios(
        token as string,
        serviceID,
        unity,
        date
      );
      if (data?.horarios?.length > 0) {
        setHoursList(data.horarios);
        setErrorMessage(undefined);
      }
    } catch (error: any) {
      if (error?.response?.data) {
        setErrorMessage(error.response.data?.message);
      }
    } finally {
      setLoadingService(false);
    }
  }

  const checkCpf = async (cpf: string) => {
    try {
      setLoading(true);
      if (cpf.length === 14) {
        const { data }: any = await checarCpf({
          cpf: removeCpfMask(cpf)
        });
        if (data?.nome) {
          setNome(data.nome);
        }
      }
    } catch (error: any) {
      toastMessage({
        type: "error",
        message: error?.response?.data?.details || "Erro ao buscar CPF"
      });
      setNome('');
      setCpfValidationMessage('Cpf não encontrado');
    } finally {
      setLoading(false);
    }
  }


  const handleClose = () => {
    !loading && setOpenSchedulerDialog(false);
  };

  const handleSchedulerOrganic = async () => {
    let cpfWithoutMask = removeCpfMask(cpf);

    if (nome && nome.length < 6) {
      setNomeValidationMessage('Nome deve ter no mínimo 6 caracteres.');
      return;
    }

    if (hasCPF) {
      if (!cpfWithoutMask) {
        setCpfValidationMessage('Informe o CPF.');
        return;
      }
      if (cpfWithoutMask.length < 11) {
        setCpfValidationMessage('CPF inválido.');
        return;
      }
    } else {
      if (identSelected && (identSelected.key === 'rg' || identSelected.key === 'titulo') && !documento) {
        setDocumentErrorMessage('Informe o seu documento.');
        return;
      }
    }

    try {
      setLoading(true);
      const token: string | null = localStorage.getItem(
        "gov_access_token_siseci"
      );

      const serviceID = isFutureDate ? searchService?.data?.id : serviceSelected?.id;
      const serviceSetor = isFutureDate ? searchService?.data?.setor_id : serviceSelected?.setor;
      const unity = isFutureDate ? unitySelected : unidade_slug;

      const { data, status } = await agendamentoOrganico(
        token || '',
        nome,
        hasCPF ? cpfWithoutMask : null,
        serviceID as number,
        serviceSetor as number,
        "Unidade",
        hourSelected ?? null,
        unity as string,
        false,
        documento ? documento : null,
        hasCPF ? 'cpf' : identSelected?.key,
        isFutureDate ? selectedDate : undefined
      );

      if (status === 201) {
        toastMessage({
          type: "success",
          message: "Agendamento realizado com sucesso!",
        });
        setSchedulerData(data);
        setIsSavedScheduler(true);
      }
    } catch (err: any) {
      if (err?.response?.status === 406) {
        setErrorAlert(true);
      }
      toastMessage({
        type: "error",
        message: err?.response?.data?.message || "Falha ao realizar agendamento!",
      });
    } finally {
      setLoading(false);
    }
  };

  const redirectToPrint = () => {
    setTimeout(() => {
      window.open(`/imprimir_agendamento/?cod=${schedulerData?.ticket}&nome=${schedulerData?.nome}&cpf=${schedulerData?.cpf}&unidade_nome=${schedulerData?.unidade_nome}&titulo_servico=${serviceSelected?.titulo ?? searchService?.data?.titulo}&documento=${schedulerData?.documento}&tipo_documento=${schedulerData?.tipo_documento}&hora=${schedulerData?.hora}&data=${schedulerData?.data}&emissao=${schedulerData?.updated_at}&protocolo=${schedulerData?.protocolo}`, '__blank');
    }, 900);
  }

  const handleSearchService = async (search: string) => {
    setValidateQueryService(false);
    const tokenSiseci: string | null = localStorage.getItem(
      'gov_access_token_siseci',
    );
    if (search.length > 2 && tokenSiseci) {
      setValidateQueryService(true);
      const { data } = await getServiceWithParams(
        {
          ativo: true,
          page: 1,
          publico_especifico: '',
          search,
          agendavel: true,
        },
        tokenSiseci,
      );
      const responseFormatted = data?.results?.map((serviceData: any) => ({
        value: serviceData.slug,
        label: serviceData.titulo,
        data: serviceData,
      }));
      // eslint-disable-next-line @typescript-eslint/no-unsafe-return
      return responseFormatted;
    }
  };

  const handleSetService = (value: any) => {
    setSearchService(value);
    setErrorMessage(undefined);
    setUnitySelected(undefined);
  };

  const handleIdentificationInfo = (data: SchedulerProps) => {
    switch (data?.tipo_documento) {
      case 'cpf':
        return `CPF: ${cpfMask(data?.cpf)}`;
      case 'rg':
        return `RG: ${data?.documento}`;
      case 'titulo':
        return `Título de eleitor: ${data?.documento}`;
      default:
        return "Não informado";
    }
  }

  const dateTomorrow = useMemo(() => {
    if (isFutureDate) {
      let todayDate = new Date();
      return todayDate.setDate(todayDate.getDate() + 1);
    }

    return new Date();
  }, [isFutureDate]);

  useEffect(() => {
    if (openSchedulerDialog && schedulerData) {
      redirectToPrint();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [openSchedulerDialog, schedulerData]);

  return (
    <Dialog
      fullWidth
      open={openSchedulerDialog}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <div style={{ display: IsSavedScheduler ? 'none' : 'initial' }}>
        <Box className={classes.headerModal}>
          <Typography className={classes.titleModal}>
            Gerar Atendimento
          </Typography>
          <IconButton onClick={handleClose} className={classes.buttonClose}>
            <Close />
          </IconButton>
        </Box>
        <DialogContent>
          <Box className={classes.boxRowPriority}>
            <Box>
              <Checkbox
                checked={isFutureDate}
                onChange={() => setIsFutureDate((oldState) => !oldState)}
                inputProps={{ 'aria-label': 'primary checkbox' }}
              />
            </Box>
            <Box>
              <Typography className={classes.labelCheckbox}>
                Você deseja agendar este atendimento para uma data futura?
              </Typography>
            </Box>
          </Box>
          <FormControl
            classes={{ root: classes.root }}
            variant="outlined"
            className={classes.formControl}
            error={typeof (nomeValidationMessage) === 'string'}
          >
            <TextField
              required
              value={nome}
              onChange={(e) => {
                setNome(e.target.value);
                setNomeValidationMessage(undefined);
              }}
              variant="outlined"
              label="Nome do cidadão"
              disabled={
                typeof (errorMessage) === 'string'
              }
              error={typeof (nomeValidationMessage) === 'string'}
            />
            {typeof (nomeValidationMessage) === 'string' && (
              <FormHelperText>{nomeValidationMessage}</FormHelperText>
            )}
          </FormControl>
          <Box className={classes.boxRowPriority}>
            <Box>
              <Checkbox
                checked={hasCPF}
                onChange={() => setHasCPF((oldState) => !oldState)}
                inputProps={{ 'aria-label': 'primary checkbox' }}
              />
            </Box>
            <Box>
              <Typography className={classes.labelCheckbox}>
                Usar CPF como identificador do cidadão?
              </Typography>
            </Box>
          </Box>
          {hasCPF ? (
            <FormControl
              classes={{ root: classes.root }}
              variant="outlined"
              className={classes.formControl}
              error={typeof (cpfValidationMessage) === 'string'}
            >
              <TextField
                value={cpf}
                onChange={(e) => {
                  setCpf(cpfMask(e.target.value));
                  setCpfValidationMessage(undefined);
                  checkCpf(e?.target?.value || '');
                  setIdentSelected({
                    ...identSelected,
                    key: 'nenhum',
                  });
                  setDocumento(undefined);
                }}
                variant="outlined"
                label="CPF do cidadão"
                error={typeof (cpfValidationMessage) === 'string'}
              />
              {typeof (cpfValidationMessage) === 'string' && (
                <FormHelperText>{cpfValidationMessage}</FormHelperText>
              )}
            </FormControl>
          ) : (
            <FormControl
              classes={{ root: classes.root }}
              variant="outlined"
              className={classes.formControl}
            >
              <InputLabel id="demo-simple-select-outlined-label">
                Selecione uma opção de identificação
              </InputLabel >
              <Select
                labelId="demo-simple-select-outlined-label"
                id="demo-simple-select-outlined"
                label="Selecione uma opção de identificação"
                onChange={() => {
                  setErrorMessage(undefined);
                  setErrorAlert(false);
                }}
                value={identSelected?.value ?? ''}
                classes={{
                  select: classes.menuItem,
                }}
              >
                {identification.map((ident) => (
                  <MenuItem
                    onClick={() => {
                      setIdentSelected(ident);
                    }}
                    value={ident.value}
                    key={ident.key}
                  >
                    {ident.value}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          )}
          {!hasCPF && identSelected && (identSelected.key === 'rg' || identSelected.key === 'titulo') && (
            <FormControl
              classes={{ root: classes.root }}
              variant="outlined"
              className={classes.formControl}
              error={typeof (documentErrorMessage) === 'string'}
            >
              <TextField
                value={documento}
                onChange={(e) => {
                  const value = e.target.value.replace(/\D/g, '');
                  setDocumento(value);
                  setDocumentErrorMessage(undefined);
                }}
                variant="outlined"
                label={`${identSelected.value}`}
                error={typeof (documentErrorMessage) === 'string'}
              />
              {typeof (documentErrorMessage) === 'string' && (
                <FormHelperText>{documentErrorMessage}</FormHelperText>
              )}
            </FormControl>
          )}
          {loadingService ? (
            <Box className={classes.boxLoadingIcon}>
              <CircularProgress />
            </Box>
          ) : (
            <>
              {!isFutureDate ? (
                <FormControl
                  classes={{ root: classes.root }}
                  variant="outlined"
                  className={classes.formControl}
                  error={typeof (errorMessage) === 'string'}
                  required
                >
                  <InputLabel id="demo-simple-select-outlined-label">
                    Selecione o serviço
                  </InputLabel >
                  <Select
                    labelId="demo-simple-select-outlined-label"
                    id="demo-simple-select-outlined"
                    label="Selecione o serviço"
                    error={typeof (errorMessage) === 'string'}
                    onChange={() => {
                      setErrorMessage(undefined);
                      setErrorAlert(false);
                    }}
                    value={serviceSelected?.id ?? ''}
                    classes={{
                      select: classes.menuItem,
                    }}
                  >
                    {service_data?.results?.map((service) => (
                      <MenuItem
                        onClick={() => {
                          setServiceSelected(service);
                          handleCheckHours(service.id, unidade_slug);
                        }}
                        value={service.id}
                        key={service.slug}
                      >
                        {service.titulo}
                      </MenuItem>
                    ))}
                  </Select>
                  {typeof (errorMessage) === 'string' && (
                    <FormHelperText>{errorMessage}</FormHelperText>
                  )}
                </FormControl>
              ) : (
                <>
                  <AsyncSelect
                    name="scheduling"
                    onChange={handleSetService}
                    placeholder="Procurar serviço"
                    value={searchService}
                    loadOptions={handleSearchService}
                    noDataMessage="Nenhum serviço encontrado"
                    validate={validateQueryService}
                  />
                  <FormControl
                    classes={{ root: classes.root }}
                    variant="outlined"
                    className={classes.formControl}
                    required
                    error={(searchService?.data && !(searchService?.data?.servicosUnidade?.length > 0)) || typeof (errorMessage) === 'string'}
                  >
                    <InputLabel id="demo-simple-select-outlined-label">
                      Selecione o local
                    </InputLabel >
                    <Select
                      labelId="demo-simple-select-outlined-label"
                      id="demo-simple-select-outlined"
                      label="Selecione o local"
                      error={(searchService?.data && !(searchService?.data?.servicosUnidade?.length > 0))}
                      disabled={!(searchService?.data?.servicosUnidade?.length > 0)}
                      onChange={(event): void => {
                        setUnitySelected(event.target.value as string);
                      }}
                      classes={{
                        select: classes.menuItem,
                      }}
                      value={unitySelected ?? ''}
                    >
                      {searchService?.data?.servicosUnidade?.map((unity: any) => (
                        <MenuItem
                          value={unity.unidade.slug_unidade}
                          key={unity.id}
                        >
                          {unity.unidade.nome}
                        </MenuItem>
                      ))}
                    </Select>
                    {((searchService?.data && !(searchService?.data?.servicosUnidade?.length > 0)) || errorMessage) && (
                      <FormHelperText>{`${errorMessage ? errorMessage : 'Nenhum local de atendimento disponível para este serviço.'}`} </FormHelperText>
                    )}
                  </FormControl>
                </>
              )}
            </>
          )}

          {isFutureDate && searchService?.data && unitySelected && (
            <>
              <div className={classes.separateLine} />
              <FormControl
                classes={{ root: classes.root }}
                disabled={!unitySelected}
                variant="outlined"
                className={classes.formControl}
              >
                <MuiPickersUtilsProvider locale={ptBR} utils={DateFnsUtils}>
                  <KeyboardDatePicker
                    disableFuture={false}
                    minDateMessage="Você não pode agendar em dias anteriores"
                    invalidDateMessage="A data informada é inválida"
                    minDate={dateTomorrow}
                    InputProps={{ className: classes.menuItem, classes: { adornedEnd: classes.adornedEnd } }}
                    autoOk
                    disabled={!unitySelected}
                    variant="inline"
                    required
                    inputVariant="outlined"
                    label="Selecionar Data"
                    format="dd/MM/yyyy"
                    value={selectedDate}
                    InputAdornmentProps={{ position: 'end', color: '#000' }}
                    onChange={(date) => {
                      if (date && isValid(date)) {
                        setSelectedDate(date);
                        if (unitySelected && searchService?.data) {
                          handleCheckHours(searchService.data.id, unitySelected, date);
                        }
                      }
                    }}
                  />
                </MuiPickersUtilsProvider>

              </FormControl>
              <FormControl
                classes={{ root: classes.root }}
                variant="outlined"
                className={classes.formControl}
                required
              >
                <InputLabel id="demo-simple-select-outlined-label">
                  Selecionar Horário
                </InputLabel >
                <Select
                  labelId="demo-simple-select-outlined-label"
                  id="demo-simple-select-outlined"
                  label="Selecionar Horário"
                  disabled={!(hoursList.length > 0)}
                  onChange={() => {
                    setErrorMessage(undefined);
                    setErrorAlert(false);
                  }}
                  value={hourSelected}
                  classes={{
                    select: classes.menuItem,
                  }}
                >
                  {hoursList?.map((hour) => (
                    <MenuItem
                      onClick={() => {
                        setHourSelected(hour);
                      }}
                      value={hour}
                      key={hour}
                    >
                      {hour}
                    </MenuItem>
                  ))}
                </Select>

              </FormControl>
            </>
          )}
          {errorAlert && (
            <FormHelperText className={classes.textError}>
              Usuário já possuí agendamento para este serviço nessa unidade.
            </FormHelperText>
          )}
          <div className={classes.buttonCloseModal}>
            {!loading && (
              <Link className={classes.link} onClick={handleClose}>
                fechar
              </Link>
            )}
            <Button
              variant="contained"
              color="primary"
              size="large"
              onClick={handleSchedulerOrganic}
              disabled={
                loading ||
                !nome ||
                (!isFutureDate ? !serviceSelected : false) ||
                (isFutureDate ? (!searchService || !unitySelected || !selectedDate || !hourSelected) : false) ||
                ((identSelected.key === 'rg' || identSelected.key === 'titulo') ? !documento : false)
              }
            >
              {!loading ? "Gerar" : <CircularProgress />}
            </Button>
          </div>
        </DialogContent>
      </div>
      {schedulerData && (
        <div style={{ display: IsSavedScheduler ? 'initial' : 'none' }}>
          <DialogTitle className={classes.headerModal}>
            <Typography className={classes.titleModal}>
              Atendimento Gerado com Sucesso!
            </Typography>
          </DialogTitle>
          <DialogContent className={classes.contentModal}>
            <MdCheckCircleOutline
              className={classes.icon}
            />
            <Box className={classes.boxInfo}>
              <Box className={classes.boxData}>
                <Typography className={classes.titleBolder}>
                  Nome
                </Typography>
                <Typography className={classes.titleLight}>
                  {schedulerData?.nome}
                </Typography>
              </Box>
              <Box className={classes.boxData}>
                <Typography className={classes.titleBolder}>
                  Identificação
                </Typography>
                <Typography className={classes.titleLight}>
                  {handleIdentificationInfo(schedulerData)}
                </Typography>
              </Box>
              <Box className={classes.boxService}>
                <Typography className={classes.titleBolder}>
                  Serviço
                </Typography>
                <Typography className={classes.titleLight}>
                  {serviceSelected?.titulo ?? searchService?.data?.titulo}
                </Typography>
              </Box>
              <Box className={classes.boxData}>
                <Typography className={classes.titleBolder}>
                  Local de atendimento
                </Typography>
                <Typography className={classes.titleLight}>
                  {schedulerData?.unidade_nome}
                </Typography>
              </Box>
              <Box className={classes.boxData}>
                <Typography className={classes.titleBolder}>
                  data/hora
                </Typography>
                <Typography className={classes.titleLight}>
                  {`${dateFormat(schedulerData?.data)} - ${schedulerData?.hora}`}
                </Typography>
              </Box>
              <Box className={classes.boxData}>
                <Typography className={classes.titleBolder}>
                  Protocolo
                </Typography>
                <Typography className={classes.titleLight}>
                  {schedulerData?.protocolo}
                </Typography>
              </Box>
            </Box>
            <a
              className={classes.linkTo}
              href={`/imprimir_agendamento/?cod=${schedulerData?.ticket}&nome=${schedulerData?.nome}&cpf=${schedulerData?.cpf}&unidade_nome=${schedulerData?.unidade_nome}&titulo_servico=${serviceSelected?.titulo ?? searchService?.data?.titulo}&documento=${schedulerData?.documento}&tipo_documento=${schedulerData?.tipo_documento}&hora=${schedulerData?.hora}&data=${schedulerData?.data}&emissao=${schedulerData?.updated_at}&protocolo=${schedulerData?.protocolo}`}
              target="_blank" rel="noreferrer"
            >
              Imprimindo comprovante...
            </a>
          </DialogContent>
          <DialogActions className={classes.footerModal}>
            <Button
              variant="contained"
              color="primary"
              size="large"
              onClick={() => history.go(0)}
              className={classes.buttonClose}
            >
              Fechar
            </Button>
          </DialogActions>
        </div>
      )}
    </Dialog>
  );
}

export default memo(DialogNotAttend);